const USA_TOGGLE_ID = "usa_gov_banner_button";
const USA_BANNER_ID = "usa_gov_banner_content";

function headerSetup() {

    setupMobileMenu();

}
headerSetup();


function setupMobileMenu() {
    const USA_TOGGLE_BUTTON = document.getElementById(USA_TOGGLE_ID);

    USA_TOGGLE_BUTTON.addEventListener('click', toggleUsaBanner);
}

function toggleUsaBanner () {
    const USA_TOGGLE_BUTTON = document.getElementById(USA_TOGGLE_ID);
    const USA_BANNER_AREA = document.getElementById(USA_BANNER_ID);

    if (USA_TOGGLE_BUTTON.classList.contains("usa-open")) {
        USA_TOGGLE_BUTTON.classList.remove("usa-open");
        USA_BANNER_AREA.classList.remove("usa-open");
        USA_BANNER_AREA.setAttribute('aria-expanded', "false");
    } else {
        USA_TOGGLE_BUTTON.classList.add("usa-open");
        USA_BANNER_AREA.classList.add("usa-open");
        USA_BANNER_AREA.setAttribute('aria-expanded', "true");
    }
}

export {headerSetup};
